import {
  FilterGroup,
  HeaderConfig,
  Row,
} from 'components/Table/KhulaSupplierTable';
import {IGroup} from 'constants/interfaces';
import moment from 'moment';
import React from 'react';
import {Box, IconButton, Tooltip} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';

export const groupTableHeaders = (): HeaderConfig[] => [
  {
    field: 'shortId',
    title: 'Group ID',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'name',
    title: 'Group Name',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'memberCount',
    title: 'Members',
    isSortable: true,
    isSearchable: false,
  },
  {
    field: 'ownerName',
    title: 'Owner',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'formattedVisibility',
    title: 'Visibility',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'formattedStatus',
    title: 'Status',
    isSortable: true,
    isSearchable: true,
  },
  {
    field: 'formattedDate',
    title: 'Created',
    isSortable: true,
    isSearchable: false,
  },
  {
    field: 'actions',
    title: '',
    isSortable: false,
    isSearchable: false,
    isRightAligned: true,
  },
];

export const groupTableRows = (
  groups: IGroup[],
  onSelect: (group: IGroup) => any,
): Row[] =>
  groups.map((group) => {
    const formattedVisibility = group.isPrivate ? 'Private' : 'Public';
    const formattedStatus = group.isArchived ? 'Archived' : 'Active';
    const formattedDate = moment(group.createdAt).format('YYYY-MM-DD');

    return {
      ...group,
      id: group.groupId,
      shortId: group.groupId.substring(0, 8) + '...',
      name: group.name,
      memberCount: group.members?.length ?? group.admins?.length ?? 0,
      ownerName:
        group.createdBy?.username || group.admins?.[0]?.username || '—',
      formattedVisibility,
      formattedStatus,
      formattedDate,
      type: formattedVisibility,
      status: formattedStatus,
      createdAt: formattedDate,
      originalData: group,
      actions: <GroupRowIcons onSelect={() => onSelect(group)} />,
    };
  });

const visibilityFilterGroup: FilterGroup = {
  name: 'Visibility',
  filters: [
    {
      field: 'formattedVisibility',
      value: 'Public',
      title: 'Public',
    },
    {
      field: 'formattedVisibility',
      value: 'Private',
      title: 'Private',
    },
  ],
};

const statusFilterGroup: FilterGroup = {
  name: 'Status',
  filters: [
    {
      field: 'formattedStatus',
      value: 'Active',
      title: 'Active',
    },
    {
      field: 'formattedStatus',
      value: 'Archived',
      title: 'Archived',
    },
  ],
};

export const groupTableFilters = [visibilityFilterGroup, statusFilterGroup];

function GroupRowIcons(props: {onSelect: () => any}) {
  return (
    <Box display="flex" flexDirection="row">
      <Tooltip title="View group" aria-label="View group">
        <IconButton
          aria-label="view group"
          size="small"
          onClick={props.onSelect}
        >
          <VisibilityIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
